import "./assets/js/app"; // メインJS
import "./assets/sass/app.scss"; // メインCSS
import "./assets/sass/base.scss";
import "./assets/sass/embla.scss";
import "./assets/sass/plyr-custom.scss"; // Plyrカスタムスタイル
import "@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "@fortawesome/fontawesome-free/css/solid.min.css";
import "@fortawesome/fontawesome-free/css/regular.min.css";
import "@fortawesome/fontawesome-free/css/brands.min.css";
import { initPlyr } from "./assets/js/plyr-init"; // Plyr動画プレイヤー

// DOMContentLoadedでPlyrを初期化
document.addEventListener('DOMContentLoaded', () => {
  initPlyr();
});
